'use strict';

var React = require('react'),
    _ = require('underscore'),
    FormMixin = require('../mixins/FormMixin'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    Icon = require('../atoms/Icon'),
    Link = require('../atoms/Link'),
    AuthTypes = require('../constants/AuthTypes'),
    FormMessage = require('./FormMessage'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./Signup.less');

var Signup = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    endpoints: React.PropTypes.array.isRequired,
    onCloseClick: React.PropTypes.func.isRequired,
    onServiceClick: React.PropTypes.func.isRequired,
    onLoginClick: React.PropTypes.func.isRequired,
    allowClose: React.PropTypes.bool.isRequired,
    showComplementaryButtons: React.PropTypes.bool
  },

  getInitialState: function () {
    return {
      showComplementaryButtons: !!this.props.showComplementaryButtons
    };
  },

  render: function () {
    return (
      <div className='Modal-body'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Sign Up
          </h3>
          {this.props.allowClose &&
            <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
              <Icon name='cross' size='small' mode='stroke' />
            </div>
          }
        </div>
        <div className='Modal-content'>
          <div className='Modal-error'>
            {this.renderErrors()}
          </div>

          <div className='Signup-services'>
            <BtnGroup vertical>
              {this.renderPrimaryButtons()}
            </BtnGroup>

            {this.state.showComplementaryButtons ? (
              <BtnGroup vertical>
                {this.renderComplementaryButtons()}
              </BtnGroup>
            ) : (
              <div className='Signup-showMore'>
                <Link onClick={this.handleShowMoreServices}
                      color='gray'
                      underline='hover'>
                  Show more options
                </Link>
              </div>
            )}
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  handleShowMoreServices: function () {
    this.setState({
      showComplementaryButtons: true
    });
  },

  renderErrors: function () {
    return _.map(_.omit(this.props.endpoints, ['email']), function (endpoint) {
      return (
        <FormMessage key={endpoint.id}
                     formLink={this.linkState(endpoint.id.toLowerCase())} />
      );
    }.bind(this));
  },

  renderComplementaryButtons: function () {
    var complementaryEndpoints = this.props.endpoints.filter(function (endpoint) {
      return !endpoint.isPrimary;
    });

    return _.map(complementaryEndpoints, function (endpoint) {
      return (
        <Button key={endpoint.id}
                href={endpoint.url}
                color={endpoint.id.toLowerCase()}
                size='large'
                onClick={this.props.onServiceClick.bind(this, endpoint.id)}
                fullWidth>
          <Icon name={endpoint.id.toLowerCase()}
                mode={endpoint.id === AuthTypes.EMAIL ? 'stroke' : 'fill'} />
          {'Sign Up with ' + endpoint.title}
        </Button>
      );
    }, this);
  },

  renderPrimaryButtons: function () {
    var primaryEndpoints = this.props.endpoints.filter(function(endpoint) {
      return endpoint.isPrimary;
    });

    return _.map(primaryEndpoints, function (endpoint) {
      return (
        <Button href={endpoint.url}
                color={endpoint.id.toLowerCase()}
                key={endpoint.id}
                size='large'
                onClick={this.props.onServiceClick.bind(this, endpoint.id)}
                fill={endpoint.isDefault}
                fullWidth>
          <Icon name={endpoint.id.toLowerCase()}
                mode={endpoint.id === AuthTypes.EMAIL ? 'stroke' : 'fill'}/>
          {'Sign Up with ' + endpoint.title}
        </Button>
      );
    }.bind(this));
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer Modal-center'>
        <p className='Modal-footerText'>
          <small>We value your privacy and won’t post anything on your behalf without your permission.</small>
          <br /><br />
          Already have an account?
          {' '}
          <Link onClick={this.props.onLoginClick}
                color='green'
                bold>
            Log In
          </Link>.
        </p>
      </div>
    );
  }
});

module.exports = Signup;



/** WEBPACK FOOTER **
 ** ./modals/Signup.jsx
 **/